<!-- General footer component for any report -->
<template>
  <div
    v-if="canViewReportingPage && !props.shortView"
    class="section-footer d-flex justify-end pr-3 py-2"
  >
    <v-btn v-if="showNotImplemented" primary secondary disabled>
      {{ tkey('footer.downloadPdf') }}
    </v-btn>
    <v-btn primary variant="flat" :disabled="props.isExportDisabled" @click="emit('export')">
      {{ t('actions.export') }}
      <template #append>
        <v-icon color="white">mdi-content-copy</v-icon>
      </template>
    </v-btn>
  </div>
</template>

<script setup>
import { useContextStore } from '@/stores/context';
import { useInternationalization } from '@/composables/use-internationalization';
import { usePermission } from '@/composables/use-permission';

const { t, tkey } = useInternationalization('reportingPage.sections');
const { canViewReportingPage } = usePermission();
const context = useContextStore();
const { showNotImplemented } = context;

const props = defineProps({
  // represents whether this report is open on (short) overview page
  shortView: {
    type: Boolean,
    required: false,
    default: false,
  },
  isExportDisabled: {
    type: Boolean,
    required: false,
    default: false,
  },
});
const emit = defineEmits(['export']);
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.section-footer {
  border-top: 1px solid $reporting-section-divider;
}
</style>
